module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_White-62b5cfa5f1ce05330a0b9d38fe2163c5.png";